export const RoutePaths = {
  VIEWPORT: "/:orgName/:projectName/:serviceName",
  PAGE_NOT_FOUND: "/",
};
